import { Link, useParams, useHistory } from "react-router-dom";
import { useState, useEffect } from "react"
import { Form, FormGroup, Input, Button, FormFeedback } from "reactstrap";
import Regex from "../../utilities/regex";
import bcrypt from "bcryptjs";
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";
import { toast } from "react-toastify";
import axios from "axios";

const CreateNewPwd = () => {
    const { userId, token } = useParams();
    let [loading, setLoading] = useState(false);
    const [disable, setdisable] = useState(false)
    const [pwd, setPwd] = useState();
    const [confirmPwd, setConfirmPwd] = useState();
    const [showPwd, setShowPwd] = useState(false);
    const [showConfirmPwd, setShowConfirmPwd] = useState(false);
    const [errors, seterrors] = useState();
    let [color, setColor] = useState("#ffffff");
    const [validate, setValidate] = useState(false);
    const history = useHistory();

    const callback = () => {
        setLoading(false)
        setdisable(false)
        setValidate(false);
    }

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        if (validate) {
            const pass = errors.pwd;
            const cPass = errors.confirmPwd;

            if (!pass && !cPass) {
                try {
                    requestResetPwd();
                } catch (error) {
                    console.error(error);
                    callback()
                    toast.error(error.message);
                }
            }
            else {
                callback();
                toast.error("Error!!! invalid values entered");
            }
        }
    }, [validate])

    const requestResetPwd = async () => {
        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/v1/auth/reset-password`, { pwd, userId, token });
        if (response.data.success) {
            history.push('/login')
            toast.success(response.data.message);
        }
        else
            toast.error(response.data.message);
        callback();
    }


    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
      `;

    // console.log("validation errors: ", errors);
    // console.log("validate: ", validate);

    // const onHandleChange = ({ target: { name, value } }) => {

    //   if (name === "email") {
    //     seterrors({ errors: { ...errors, [name]: false, }, [name]: value.replace(/\s/g, ""), });
    //   } else {
    //     seterrors({ errors: { ...errors, [name]: false, }, [name]: value, });
    //   }
    // };




    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setdisable(true);
        let obj = { pwd: false, confirmPwd: false };

        if (!Regex.password(pwd)) {
            obj = { ...obj, pwd: true };
        }

        if (pwd !== confirmPwd) {
            obj = { ...obj, confirmPwd: true };
        }

        seterrors(obj);
        setValidate(true);
    };


    return (
        <div className="col-12 wrapper main-bggrey p-0">
            <div className="col-12 inner-page-content login-page px-0 d-flex justify-content-center align-items-center ">
                <div id="login" className="col-sm-12  my-4">
                    <div className="login-container col-sm-8 col-md-6 col-lg-4 col-xl-4 m-auto bg-white boxshadow border-radius8">
                        <div id="login-row" className="row justify-content-center align-items-center ">
                            <div id="login-column" className="w-100">
                                <h3 className="text-center page-head font-weight-bold  txtcolor">Reset Password</h3>
                                <h5 className="col-md-10 px-md-4 m-auto text-center txt-lghtblue page-subhead  pb-2">Your new password must be different from
                                    previous used password</h5>
                                <div id="login-box" className="col-md-12 mt-4">
                                    <Form id="login-form" className="form site-form" onSubmit={handleSubmit}>
                                        <FormGroup className="form-group position-relative mb-4">
                                            <Input type={showPwd ? "type" : "password"} name="newPwd" id="newPwd" className="form-control input-style min-input" placeholder="New password" onChange={e => setPwd(e.target.value)} invalid={(pwd && !Regex.password(pwd))} required />
                                            <Link to={window.location.pathname} className="pwd-show"
                                                onClick={() =>
                                                    setShowPwd(!showPwd)
                                                }
                                                style={{ cursor: "pointer" }}>
                                                {showPwd ? "Hide" : "Show"}
                                            </Link>
                                            <FormFeedback id="password-err">
                                                Password must be minimum 6 characters, at least one uppercase letter, one lowercase letter, one number and one special character
                                            </FormFeedback>
                                        </FormGroup>
                                        <FormGroup className="form-group position-relative  mb-2">
                                            <Input type={showConfirmPwd ? "type" : "password"} name="confirmPwd" id="confirmPwd" className="form-control input-style min-input" placeholder="Confirm password" onChange={e => setConfirmPwd(e.target.value)} invalid={(pwd !== confirmPwd)} required />
                                            <Link to={window.location.pathname} className="pwd-show"
                                                onClick={() =>
                                                    setShowConfirmPwd(!showConfirmPwd)
                                                }
                                                style={{ cursor: "pointer" }}>
                                                {showConfirmPwd ? "Hide" : "Show"}
                                            </Link>
                                            <FormFeedback id="confirm-password-err">
                                                Passwords don't match
                                            </FormFeedback>
                                        </FormGroup>
                                        <FormGroup className="form-group mt-4 mb-0">
                                            <button type="submit" className="btn  text-white w-100 btn-custom min-input mt-3" disabled={disable} >
                                                {loading && <SyncLoader color={color} loading={loading} css={override} size={11} />}
                                                {!loading && <span>Submit</span>}
                                            </button>
                                        </FormGroup>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default CreateNewPwd;